var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.shipping == 14
    ? _c("div", [
        _c("p", { staticClass: "alert alert-warning text-center" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$translate("Woerner::Template.AngebotBerechnung")) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "widget-success" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-block",
              attrs: { id: "button_angebot", disabled: _vm.loading },
              on: {
                click: function($event) {
                  return _vm.doPlaceAngebot()
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$translate("Woerner::Template.AngebotCheckout")) +
                  "\n            "
              ),
              _c("icon", {
                attrs: { icon: "arrow-right", loading: _vm.loading }
              })
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }